1`<app-dialog-container (onClose)="closeDialog()">
    <div class="flex flex-col gap-4 md:px-0 sm:px-6">
        <form [formGroup]="captureForm" *ngIf="!submitted">
            <div class="md:max-h-[50vh] max-h-[80vh] overflow-y-auto">
                <h1 class="text-2xl font-bold text-black space-y-8 sm:space-y-6 mb-4">{{dialogTitle}}</h1>
                <div class="flex flex-col gap-4 border-b border-gray-900/10 pb-8">
                    <div class="grow">
                        <label for="firstName" class="block text-sm font-medium leading-6" i18n>First Name<sup>*</sup></label>
                        <input
                            formControlName="firstName"
                            placeholder="Your Name"
                            required
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="
                                !captureForm.get('firstName')?.pristine &&
                                captureForm.get('firstName')?.hasError('required')
                            "
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter your first name.
                        </div>
                    </div>
                    <div class="grow">
                        <label for="lastName" class="block text-sm font-medium leading-6" i18n>Last Name(s)<sup>*</sup></label>
                        <input
                            formControlName="lastName"
                            placeholder="Your Name"
                            required
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="
                                !captureForm.get('lastName')?.pristine && captureForm.get('lastName')?.hasError('required')
                            "
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter your last name(s).
                        </div>
                    </div>
                    <div class="grow">
                        <label for="email" class="block text-sm font-medium leading-6" i18n>Email Address<sup>*</sup></label>
                        <input
                            formControlName="email"
                            placeholder="Email Address"
                            required
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                        <div
                            *ngIf="!captureForm.get('email')?.pristine && captureForm.get('email')?.hasError('required')"
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter your email address.
                        </div>
                        <div
                            *ngIf="
                                !captureForm.get('email')?.pristine &&
                                !captureForm.get('email')?.hasError('required') &&
                                captureForm.get('email').hasError('email')
                            "
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must enter a valid email address.
                        </div>
                    </div>
                    <div class="grow">
                        <label for="phone" class="block text-sm font-medium leading-6" i18n>Telephone Number</label>
                        <input
                            formControlName="phone"
                            placeholder="Telephone Number"
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                    <div *ngIf="job?.showLocationField" class="grow">
                        <label for="location" class="block text-sm font-medium leading-6" i18n>Your location</label>
                        <input
                            formControlName="location"
                            placeholder="Your Location"
                            class="block w-full rounded-md border-0 p-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                    <div class="grow" *ngIf="job?.delayCvOnMobile">
                        <label for="delayCV" class="block md:hidden text-sm font-medium leading-6" i18n
                            >Would you like to upload Your CV/Resume later on via email?</label
                        >
                        <input type="checkbox" formControlName="delayCV" />
                    </div>
                    <div class="grow" *ngIf="!captureForm.get('delayCV').value">
                        <label for="cv" class="block text-sm font-medium leading-6" i18n>Your CV/Resume</label>
                        <p class="block text-sm font-medium leading-6" *ngIf="payload.file?.originalName">
                            {{ payload.file.originalName }} uploaded {{ payload.file.uploaded | date : "short" }}
                        </p>
                        <input type="file" name="cv" (change)="onFileUpload($event)" />
                        <div
                            *ngIf="
                                !captureForm.get('delayCV').value &&
                                !captureForm.get('cv')?.pristine &&
                                !captureForm.get('cv')?.hasError('required') &&
                                !payload?.cv?.filename &&
                                !payload.file?.originalName
                            "
                            class="text-red-500 text-sm mt-1"
                            i18n>
                            You must upload your CV/Resume.
                        </div>
                    </div>
                </div>
                <div class="flex flex-col gap-4 pb-8 mt-8">
                    <div class="grow relative flex items-start" *ngIf="job?.rightToWorkInUK">
                        <div class="flex h-6 items-center">
                            <input
                                type="checkbox"
                                formControlName="rightToWorkInUK"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                        </div>
                        <div class="ml-3 text-sm leading-6">
                            <label for="comments" class="text-sm font-medium leading-6" i18n
                                >Do you have the right to work in the advertised location?</label
                            >
                        </div>
                    </div>
                    <div class="grow relative flex items-start">
                        <div class="flex h-6 items-center">
                            <input
                                type="checkbox"
                                formControlName="relatedJobsConsent"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                        </div>
                        <div class="ml-3 text-sm leading-6">
                            <label for="comments" class="text-sm font-medium leading-6" i18n
                                >Can {{ (client$ | async)?.displayName || (client$ | async)?.name || "we" }} contact you
                                in the future about other roles similar to this?</label
                            >
                        </div>
                    </div>
                    <div class="grow relative flex items-start">
                        <div class="flex h-6 items-center">
                            <input
                                formControlName="terms"
                                type="checkbox"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                        </div>
                        <div class="ml-3 text-sm leading-6">
                            <label for="terms" class="font-medium text-gray-900" i18n
                                >I have read and agree to the terms of use and privacy statement.<sup>*</sup></label
                            >
                            <p class="text-gray-500">
                                Voyse and {{ (client$ | async)?.displayName || (client$ | async)?.name }}'s
                                <a
                                    class="text-indigo-600 font-bold"
                                    href="http://www.voyse.co.uk/terms"
                                    rel="nofollow"
                                    target="_blank"
                                    >terms</a
                                >
                                and
                                <a
                                    class="text-indigo-600 font-bold"
                                    href="http://www.voyse.co.uk/privacy"
                                    rel="nofollow"
                                    target="_blank"
                                    >privacy statements</a
                                >
                                can be found here.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                <button
                    class="inline-flex items-center cursor-pointer disabled:bg-blue-300 disabled:text-white/50 disabled:cursor-not-allowed"
                    [ngClass]="applyButtonClasses"
                    [disabled]="
                        submitting ||
                        captureForm.invalid ||
                        (!captureForm.get('delayCV').value && !payload?.cv?.filename && !payload.file?.originalName)
                    "
                    (click)="apply()"
                    i18n>
                    <svg
                        *ngIf="submitting"
                        class="animate-spin -ml-1 mr-1 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24">
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"></circle>
                        <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Submit
                </button>
            </div>
        </form>

        <div *ngIf="submitted && !finalised">
            <h1 class="text-2xl font-bold text-black space-y-8 sm:space-y-6" i18n>How did we do?</h1>
            <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
                Good luck with your application! How did you find your candidate experience using Voyse today?
            </p>
            <app-star-rating></app-star-rating>
        </div>

        <div *ngIf="submitted && finalised">
            <h1 class="text-2xl font-bold text-black space-y-8 sm:space-y-6" i18n>Good luck with your application</h1>
            <p class="block text-sm font-medium leading-6 text-gray-500 mb-4" i18n>
                Thanks for registering your interest in {{ (client$ | async)?.displayName || (client$ | async)?.name }}.
                We'll keep you up to date on news regarding our upcoming
    roles.
            </p>
        </div>
    </div>
</app-dialog-container>
